<app-modal>
  <app-loading *ngIf="isLoading"></app-loading>
  <ng-container *ngIf="!isLoading">
    <app-modal-header
      [title]="T.common.add_item | translate: { item: localisedAction }"
      [showDelete]="false"
      (closed)="closeModal()">
    </app-modal-header>

    <app-modal-body>
      <div class="validations-erros-container" *ngIf="validationErrors?.length > 0">
        <div class="validation-error" *ngFor="let error of validationErrors">
          <i class="material-symbols-outlined">error_outline</i>
          {{ error }}
        </div>
      </div>
      <section class="row custom-gutters section-padding" [formGroup]="form">
        <div class="d-flex col-12 mb-3">
          <app-text-field
            [displayError]="triggerErrors"
            [autofocus]="true"
            class="flex-fill modal-action"
            formControlName="actionTitle"
            [disableMargin]="true"
            icon="library_add_check"
            [placeholder]="(T.common.item_title | translate: { item: localisedAction }) + '*'"
            [formGroup]="form"
            [maxLength]="250"
            [useReactiveMessages]="true">
          </app-text-field>
        </div>
        <div class="col-12 mb-3">
          <app-filter-dropdown-new
            class="modal-risk"
            [displayError]="triggerErrors"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Risk"
            [disableMargin]="true"
            [required]="true"
            [singleSelect]="false"
            [appliedFilters]="filters"
            [typeahead]="true"
            icon="warning"
            [label]="(T.common.risk | translate) + '*'"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>
        <div class="col-lg-9 col-12 mb-3">
          <app-filter-dropdown-new
            [useSearch]="false"
            [displayError]="triggerErrors"
            [required]="true"
            [filterByModuleObjectType]="false"
            [currentlySelectedSettingValue]="String(typeValue)"
            [filterType]="filterTypes.Risk_Action_Type"
            [singleSelect]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            (onFilterUpdate)="handleFilterChange($event)"
            [label]="(T.common.type.one | translate) + '*'">
          </app-filter-dropdown-new>
        </div>
        <div class="col-lg-3 col-12 mb-3">
          <app-filter-dropdown-new
            [useSearch]="false"
            [displayError]="triggerErrors"
            [currentlySelectedSettingValue]="String(statusValue)"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Risk_Action_Status"
            [disableMargin]="true"
            [singleSelect]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            (onFilterUpdate)="handleFilterChange($event)"
            [label]="T.common.status.one | translate">
          </app-filter-dropdown-new>
        </div>
        <div class="col-lg-3 col-12 d-flex mb-3" *ngIf="!dateReseter">
          <app-datepicker
            [date]="getDueDate"
            [minDate]="today"
            (dateChanged)="setDueDate($event)"
            [placeholder]="T.defaultLocalizations.due_date.one | translate"
            [showPlaceholderFirst]="true"
            [disableMargin]="true"
          ></app-datepicker>
        </div>
        <div class="description col-12 mb-3">
          <app-details-editable-field
            [input]="form.controls.description.value ? form.controls.description.value : ''"
            [header]="T.defaultLocalizations.description.one | translate"
            [type]="editableFieldTypes.RichText"
            [canEdit]="true"
            (onUpdate)="updateDescription($event)"
            (onInputChange)="updateDescription($event)"
            (isInvalid)="isDescriptionInvalid($event)"
            [placeholder]="T.common.add_description | translate"
          ></app-details-editable-field>
        </div>

        <div class="container-with-bottom-element d-flex flex-column col-12 mb-3">
          <div class="selection">
            <app-filter-dropdown-new
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Owner"
              [appliedFilters]="filters"
              [disableMargin]="true"
              [typeahead]="true"
              [label]="T.common.assign_owner.many | translate"
              (onFilterUpdate)="handleFilterChange($event)"
            ></app-filter-dropdown-new>
          </div>
          <div class="bottom-element d-flex">
            <app-button-transparent
              size="small"
              icon="add"
              [text]="T.common.assign_me | translate"
              (clicked)="setAccountForCurrentOwner()"
            ></app-button-transparent>
          </div>
        </div>

        <div class="d-flex flex-column col-12">
          <app-filter-dropdown-new
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.User_Group"
            [appliedFilters]="filters"
            [disableMargin]="true"
            [typeahead]="true"
            [label]="T.common.assign_group_s | translate"
            (onFilterUpdate)="handleFilterChange($event)"
          ></app-filter-dropdown-new>
        </div>
      </section>
    </app-modal-body>

    <app-modal-footer>
      <app-button-rectangle
        class="button d-none d-md-block"
        size="large"
        [text]="T.common.close | translate"
        buttonTheme="white"
        (clicked)="confirmClose()"
      ></app-button-rectangle>
      <app-button-rectangle
        class="button"
        size="large"
        [disabled]="!validateState()"
        [text]="T.common.save | translate"
        buttonTheme="primary"
        (clicked)="onSave()"
      ></app-button-rectangle>
    </app-modal-footer>
  </ng-container>
</app-modal>
